// The store front's cookie banner (aldoo-ra Tracking/ConsentBanner) in the
// site's language; the footer's "Cookie settings" opens it again.
import React from "react"
import ConsentBannerBase from "aldoo-ra/Tracking/ConsentBanner"
import useT from "./hooks/useT"
import useSiteLanguage from "./hooks/useSiteLanguage"

export default function ConsentBanner() {
  const t = useT()
  const language = useSiteLanguage()
  return (
    <ConsentBannerBase
      labels={{
        title: t`This site uses cookies`,
        text: t`We use cookies for analytics and to measure our ads, so we can improve the store and show relevant offers. You can turn them off below; the store works either way.`,
        shortText: t`We use cookies for analytics and to measure our ads.`,
        ok: "OK",
        enable: t`Allow cookies`,
        policy: t`Privacy Policy`,
        policyHref: language === "en" ? "/privacy-policy" : `/${language}/privacy-policy`,
        logo: "/static/p-images/aldoo--277x58.webp",
        company: "Aldoo Ltd",
      }}
    />
  )
}
